module.exports = __webpack_public_path__ + "static/img/Home Applications.c617f1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applications/Home Applications.jpg
// module id = mKrg
// module chunks = 1